import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgParkeren = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="M29 7H11v26h18z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M20 13a5 5 0 0 1 0 10h-2v5h-3V13zm0 3h-2v4h2a2 2 0 1 0 0-4"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M29 7H11v26h18z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M20 13a5 5 0 0 1 0 10h-2v5h-3V13zm0 3h-2v4h2a2 2 0 1 0 0-4"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M29.5 18h1v13.5H21v-1h8.5zm-16-11.5V11h-1V5.5H17v1z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgParkeren);

export default ForwardRef;
